import { Button } from '@bm-js/atlascloud-ui'
import Input from './Input'
import { ChangeEvent } from '@bm-js/atlascloud-shared'

type Props = {
  formData: {
    otp: string
  }
  handleChange: (e: ChangeEvent) => void
  submit: (e: React.FormEvent<HTMLFormElement>) => void
  loading: boolean
  errors: {
    otp?: string
  }
}

const GetStartedOTP = ({
  formData,
  handleChange,
  submit,
  loading,
  errors,
}: Props) => {
  return (
    <div>
      <form onSubmit={submit} className='flex flex-col'>
        <p className='mb-2 leading-5'>
          Vi har skickat en verifieringskod till din mailadress.
        </p>
        <Input
          disabled={loading}
          autoFocus
          label='Ange din 6-siffriga kod'
          type='otp'
          error={errors.otp}
          value={formData.otp}
          onChange={handleChange}
          name='otp'
          required
        />
        <Button className='self-end' disabled={loading} type='submit'>
          {loading ? 'Verifierar...' : 'Verifiera'}{' '}
        </Button>
      </form>
    </div>
  )
}

export default GetStartedOTP
